// @flow

import addOrderCaveat from '../../../Services/addOrderCaveat';
import type { AddOrderCaveatParams } from '../../../types';

export default (params: AddOrderCaveatParams) => async (dispatch: Function) => dispatch(addOrderCaveat(params))